import { useState, useRef, useCallback, useEffect } from "react";
import { useCoreApp } from "@/contexts/CoreAppContext";

/**
 * Hook to manage slider hint functionality
 * - Flashes a purple shadow on cards (1000ms)
 * - Shows a floating hint message (3000ms)
 */
export const useSliderHint = () => {
    const { setShowSliderHint } = useCoreApp();
    const [showFloatingHint, setShowFloatingHint] = useState(false);
    const hintTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const triggerSliderHint = useCallback(() => {
        // Clear any existing hint timeout
        if (hintTimeoutRef.current) {
            clearTimeout(hintTimeoutRef.current);
        }

        // Flash purple shadow on cards (1000ms)
        setShowSliderHint(true);
        setTimeout(() => setShowSliderHint(false), 1000);

        // Show floating hint message (3 seconds)
        setShowFloatingHint(true);
        hintTimeoutRef.current = setTimeout(() => {
            setShowFloatingHint(false);
        }, 3000);
    }, [setShowSliderHint]);

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (hintTimeoutRef.current) {
                clearTimeout(hintTimeoutRef.current);
            }
        };
    }, []);

    return { showFloatingHint, triggerSliderHint };
};
